import {Component, ElementRef, ViewChild} from '@angular/core';
import {Events, PopoverController} from 'ionic-angular';

import { PopoverPage } from '../about-popover/about-popover';

import {  ToastController } from 'ionic-angular';
import {
    MediaCapture, MediaFile, CaptureError, CaptureImageOptions,
    CaptureVideoOptions
} from '@ionic-native/media-capture';
import {UploadService} from "../../services/upload-service";
import * as firebase from "firebase";
import {Upload} from "../../services/upload";
import {UserData} from "../../providers/user-data";
import { File } from '@ionic-native/file';
//import {  videojs } from '@app/videojs';
//import * as toto from '../../../node_modules/videojs-record/dist/videojs.record';
//import * as HLS from "videojs-record"
declare var videojs;
declare var RecordRTC;
declare var cordova;

@Component({
  selector: 'page-test',
  templateUrl: 'test.html'
})
export class TestPage {
  conferenceDate = '2047-05-17';
  public planning = {
      'test':'yoyo',
      'test4':'yoyo',
      'test5':'yoyo',
  };
  calendar: any;
  @ViewChild('myVideo') videoElement: ElementRef;


  constructor(
      public popoverCtrl: PopoverController,
      private mediaCapture: MediaCapture,
      public toastCtrl: ToastController,
      public uploadService: UploadService,
      public userData: UserData,
      private fileManager: File,
      public events: Events
  ) {

  }
  calendarLoaded(data)
  {
      this.calendar = data.calendar;
      this.calendar.pushPlanning('test');
  }

  presentPopover(event: Event) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({ ev: event });
  }
  ionViewDidLoad() {
      console.log('subcribe');
      this.events.subscribe('user:test', () => {
          var that = this;
          console.log('listen');
          const toast = this.toastCtrl.create({
              message: 'user:test',
              showCloseButton: true,
              cssClass: 'danger',
              closeButtonText: 'Ok',
              dismissOnPageChange: true,
              duration:2000
          });
          toast.present();
      });
  }
  launchevent()
  {
      console.log('launch');
      this.events.publish('user:test');
  }
  testCapture() {
      console.log('here IS');
      console.log("oups");
      //var video = this.videoElement.nativeElement;
      var video: any = document.getElementById('myVideo');
      video.style.width = '300px';
      video.style.height = '300px';
      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      /*if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.log('not defined');
          navigator.mediaDevices.getUserMedia = (navigator['getUserMedia'] ||
              navigator['webkitGetUserMedia'] || navigator['mozGetUserMedia'] ||
              navigator['msGetUserMedia']);
      }*/

      var constraints = {
          audio: true,
          video: {
              facingMode: 'user'
          }
      }
      if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)
      {
          cordova.plugins.iosrtc.getUserMedia(
              // constraints
              { audio: true, video: true },
              // success callback
              function (stream) {
                  console.log('got local MediaStream: ', stream);
                  video.srcObject = stream;
                  video.autoplay = true;
                  //pc.addStream(stream);
              },
              // failure callback
              function (error) {
                  console.error('getUserMedia failed: ', error);
              }
          );
      }
      else{
          navigator.mediaDevices.getUserMedia(constraints).then(function success(stream) {
              video.srcObject = stream;
              console.log('ici');
          }).catch(function(error) {
              console.log(error);
          });
      }


      console.log("la");

      /*navigator.mediaDevices.getUserMedia = navigator.mediaDevices.getUserMedia || navigator.getUserMedia ;

      var player = videojs("myVideo", {
          videoMimeType:"video/mp4",
          controls: true,
          width: 320,
          height: 240,
          fluid: false,
          plugins: {
              record: {
                  audio: true,
                  video: true,
                  maxLength: 10,
                  debug: true
              }
          }
      }, function(){
          // print version information at startup
          videojs.log('Using video.js', videojs.VERSION,
              'with videojs-record', videojs.getPluginVersion('record'),
              'and recordrtc', RecordRTC.version);
      });*/
     /* var player = HLS.videojs("myVideo", {
          controls: true,
          width: 320,
          height: 240,
          fluid: false,
          plugins: {
              record: {
                  audio: true,
                  video: true,
                  maxLength: 10,
                  debug: true
              }
          }
      }, function(){
          // print version information at startup
          HLS.videojs.log('Using video.js', HLS.videojs.VERSION,
              'with videojs-record', HLS.videojs.getPluginVersion('record'),
              'and recordrtc', HLS.RecordRTC.version);
      });*/

  }
  testVideoJS(){
      navigator.mediaDevices.getUserMedia = navigator.mediaDevices.getUserMedia || navigator.getUserMedia || cordova.plugins.iosrtc.getUserMedia;
      var player = videojs("myVideo", {
          videoMimeType:"video/mp4",
          controls: true,
          width: 320,
          height: 240,
          fluid: false,
          plugins: {
              record: {
                  audio: true,
                  video: true,
                  maxLength: 10,
                  debug: true
              }
          }
      }, function(){
          // print version information at startup
          videojs.log('Using video.js', videojs.VERSION,
              'with videojs-record', videojs.getPluginVersion('record'),
              'and recordrtc', RecordRTC.version);
      });
  }
  captureMediaImage() {
      let toast = this.toastCtrl.create({
          message: 'trying to reach media capture',
          duration: 3000
      });
      toast.present();
      let options: CaptureImageOptions = { limit: 3 };
      var that = this;
      this.mediaCapture.captureImage(options)
          .then(
              function(data: MediaFile[]) {
                  let unused = data;
                  let toast = that.toastCtrl.create({
                      message: "Cool",
                      duration: 3000
                  });
                  toast.present();
                  data=null;
              },
              function(err: CaptureError) {
                  let toast = that.toastCtrl.create({
                      message: "Error code " + err.code,
                      duration: 3000
                  });
                  toast.present();
              },
          );
  }
    captureMediaVideo() {
        let toast = this.toastCtrl.create({
            message: 'trying to reach media capture',
            duration: 3000
        });
        toast.present();
        let options: CaptureVideoOptions = { limit: 1,duration:30,quality:0 };
        var that = this;
        this.mediaCapture.captureVideo(options)
            .then(
                function(data) {
                    var mediaFile = data[0];
                    let path = mediaFile.localURL;
                    console.log(path);
                    /*mediaFile.getFormatData(
                        function(mediaFileData){
                            console.log(mediaFileData);
                            console.log(mediaFileData.duration);
                        },
                        function(error){},
                    );*/
                    console.log('WILL UPLOAD');
                    var upload = new Upload(mediaFile);
                    upload.document_type = "video";
                    upload.specific_root='users/'+that.userData.token+'/oups/';

                    var basePath = that.userData.getUploadRoot();
                    console.log('WILL START UPLOAD');
                    let storageRef = firebase.storage().ref();
                    console.log(mediaFile);

                    try{

                        console.log('START UPLOAD '+path);
                        that.fileManager.resolveLocalFilesystemUrl(path).then(function(path) {
                            console.log(path);
                            var pathes = path.nativeURL.split('/');
                            var name = pathes.pop();
                            var dir = pathes.join('/');
                            console.log('START UPLOAD 2'+dir+' -- '+name);


                            that.fileManager.readAsDataURL(dir,name).
                            then(function(dataUrl){
                                console.log("2");//console.log(dataUrl);
                                let uploadTask = storageRef.child(`${basePath}/${name}`).putString(dataUrl, 'data_url');
                                uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                                    (snapshot: any) =>  {
                                        // upload in progress
                                        upload.progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100 );
                                        console.log(upload.progress);
                                    },
                                    (error) => {
                                        // upload failed
                                        console.log(error)
                                    },
                                    () => {
                                        // upload success
                                        upload.url = uploadTask.snapshot.downloadURL
                                        upload.name = upload.file.name
                                        console.log('SUCCESS')
                                    }
                                );
                            }).
                            catch(function(e){console.log(e);});

                        }).catch(function(e){console.log(e);});;
                    /*that.fileManager.readAsDataURL(path,name).then(function(dataUrl){
                        console.log("callback");
                        //let uploadTask = storageRef.child(`${basePath}${upload.file.name}`).put(upload.file);
                        console.log(`${this.basePath}/${name}`);
                        let uploadTask = storageRef.child(`${this.basePath}/${name}`).putString(dataUrl, 'data_url');
                        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                            (snapshot: any) =>  {
                                // upload in progress
                                upload.progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100 );
                                console.log(upload.progress);
                            },
                            (error) => {
                                // upload failed
                                console.log(error)
                            },
                            () => {
                                // upload success
                                upload.url = uploadTask.snapshot.downloadURL
                                upload.name = upload.file.name
                                console.log('SUCCESS')
                            }
                        );
                    }).catch(function(e){console.log(e);});*/


                    }catch(e){console.log(e);}

                    let toast = that.toastCtrl.create({
                        message: "Cool",
                        duration: 3000
                    });
                    toast.present();
                    data=null;
                },
                function(err: CaptureError) {
                    let toast = that.toastCtrl.create({
                        message: "Error code " + err.code,
                        duration: 3000
                    });
                    toast.present();

                },
            );
    }


}



// WEBPACK FOOTER //
// ./src/pages/test/test.ts